module.exports = __webpack_public_path__ + "assets/icon-permanentPosts-woodenPermanent.6078c882.svg";